import { auditLogConstants } from "../constants/auditLog.constants";

export function auditLog(state = {}, action) {
  switch (action.type) {
    case auditLogConstants.GET_REQUEST:
      return {
        ...state,
        loading: true,
        request: action.payload,
        error: false,
      };
    case auditLogConstants.GET_SUCCESS:
      return {
        ...state,
        loading: false,
        paginatedResult: action.payload,
      };
    case auditLogConstants.GET_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case auditLogConstants.GET_BY_ID_REQUEST:
      return {
        ...state,
        loadingDetail: true,
        error: false,
      };
    case auditLogConstants.GET_BY_ID_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        selectedAuditLog: action.payload,
      };
    case auditLogConstants.GET_BY_ID_FAILURE:
      return {
        ...state,
        loadingDetail: false,
        error: true,
      };
    default:
      return state;
  }
}
